import React from 'react';
import { InputFormGroup, InputFormGroupProps } from '../InputFormGroup/InputFormGroup';
import SchoolDomainInput from '../SchoolDomainInput/SchoolDomainInput';

function SchoolDomainInputGroup(props: InputFormGroupProps) {
  return <InputFormGroup inputComponent={SchoolDomainInput} {...props} />;
}

export default SchoolDomainInputGroup;
